import { z } from 'zod';

/**
 * Mirrors the backend UserHint enum from src/server/src/http/error.rs
 */
export enum UserHint {
  BadCredentials = 'BadCredentials',
  NotSignedIn = 'NotSignedIn',
  ResourceNotFound = 'ResourceNotFound',
  InsufficientPermissions = 'InsufficientPermissions',
  MentionedUserNotInGroupRelatedToPost = 'MentionedUserNotInGroupRelatedToPost',
  BadRequestLikelyBug = 'BadRequestLikelyBug',
  EmailNotVerified = 'EmailNotVerified',
  InvalidToken = 'InvalidToken',
  Todo = 'Todo',
}

/**
 * Zod schema for error responses from the API
 */
export const ApiErrorResponseSchema = z.object({
  message: z.string(),
  details: z.any().optional(),
});

/**
 * Structure of error responses from the API
 */
export type ApiErrorResponse = z.infer<typeof ApiErrorResponseSchema>;
